<template>
  <div>
    <v-fade-transition>
      <crud-detail
        :update-mode="updateMode"
        :showButton="false"
        class="mt-2"
        :next="next"
        :modalLeave="modalLeave"
        @closeLeave="modalLeave = false"
      >
        <headers-detail>
          <v-btn dark @click="customSave" color="redExtraciem">
            {{ $t('button.save') }}
          </v-btn>
        </headers-detail>

        <v-layout row :class="'pr-2 pl-2 pt-3'">
          <v-flex md12>
            <v-card class="specific">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>mdi-home-account</v-icon>
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.adresseGeographique')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-layout row>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.adresse.ligne1"
                        :label="$t('adresse.ligne1.etablissement.label')"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.adresse.ligne2"
                        :label="$t('adresse.ligne2.etablissement.label')"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.adresse.ligne3"
                        :label="$t('adresse.ligne3.label')"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md1>
                      <v-text-field
                        v-model="form.adresse.numeroVoie"
                        :label="$t('adresse.numeroVoie')"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                    <v-flex md3>
                      <enum-entity-field
                        namespace="typevoie"
                        :additionalField="Array.from(['raccourci'])"
                        v-model="form.adresse.typeVoie"
                        i18n="adresse.typeVoie"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.adresse.nomVoie"
                        :label="$t('adresse.nomVoie')"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.adresse.ligne5"
                        :label="$t('adresse.ligne5.label')"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md4>
                      <v-text-field
                        v-model="form.adresse.codePostal"
                        :label="$t('adresse.codePostal')"
                        :error-messages="$errors($v.form.adresse.codePostal)"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-combobox
                        :value="form.adresse.localite"
                        :items="communesPossibles"
                        :search-input.sync="localLocalite"
                        :label="$t('adresse.localite.particulier')"
                        :menu-props="{ value: localiteVisible }"
                        @focus="localiteVisible = true"
                        @click="localiteVisible = true"
                        @blur="localiteVisible = false"
                        @input="
                          localiteVisible = false
                          form.adresse.localite = $event
                        "
                        :no-data-text="$t('noDataText')"
                        :readonly="isCorrespondantEntreprise"
                      ></v-combobox>
                    </v-flex>
                    <v-flex md4>
                      <enum-entity-field
                        namespace="pays"
                        v-model="form.adresse.pays"
                        :additionalField="
                          Array.from(['unionEuropeenne', 'raccourci'])
                        "
                        i18n="adresse.pays"
                        sortBy="label"
                        :validation="$v.form.adresse.pays"
                        :readonly="isCorrespondantEntreprise"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-card class="specific" v-if="isCorrespondantEtablissement">
              <v-card-title class="headerCardIndigo white--text">
                <v-icon dark>mdi-home-account</v-icon>&nbsp;&nbsp;
                <span style="margin-left: 5px">{{
                  $t('correspondant.details.adresseFacturation')
                }}</span>
              </v-card-title>
              <v-layout row class="ma-2 pa-1">
                <v-flex md12>
                  <v-row>
                    <v-col md="4">
                      <v-checkbox
                        v-model="form.adresseFacturationIdentique"
                        :label="
                          $t(
                            'correspondant.details.utiliserAdresseGeographique',
                          )
                        "
                        color="primary"
                      />
                    </v-col>
                    <v-col md="4"> </v-col>
                  </v-row>
                  <v-layout row>
                    <v-flex md4>
                      <v-text-field
                        v-model="currentAdresse.ligne1"
                        :label="$t('adresse.ligne1.etablissement.label')"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="currentAdresse.ligne2"
                        :label="$t('adresse.ligne2.etablissement.label')"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="currentAdresse.ligne3"
                        :label="$t('adresse.ligne3.label')"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md1>
                      <v-text-field
                        v-model="currentAdresse.numeroVoie"
                        :label="$t('adresse.numeroVoie')"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                    <v-flex md3>
                      <enum-entity-field
                        namespace="typevoie"
                        :additionalField="Array.from(['raccourci'])"
                        v-model="currentAdresse.typeVoie"
                        i18n="adresse.typeVoie"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="currentAdresse.nomVoie"
                        :label="$t('adresse.nomVoie')"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="currentAdresse.ligne5"
                        :label="$t('adresse.ligne5.label')"
                        :disabled="form.adresseFacturationIdentique"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md4>
                      <v-text-field
                        v-model="currentAdresse.codePostal"
                        :label="$t('adresse.codePostal')"
                        :disabled="form.adresseFacturationIdentique"
                        :error-messages="
                          $errors($v.form.adresseFacturation.codePostal)
                        "
                      />
                    </v-flex>
                    <v-flex md4>
                      <v-combobox
                        :value="currentAdresse.localite"
                        :items="communesPossiblesFacturation"
                        :search-input.sync="localLocaliteFacturation"
                        :label="$t('adresse.localite.particulier')"
                        :menu-props="{ value: localiteFacturationVisible }"
                        :disabled="form.adresseFacturationIdentique"
                        @focus="localiteFacturationVisible = true"
                        @click="localiteFacturationVisible = true"
                        @blur="localiteFacturationVisible = false"
                        @input="
                          localiteFacturationVisible = false
                          currentAdresse.localite = $event
                        "
                        :no-data-text="$t('noDataText')"
                      ></v-combobox>
                    </v-flex>
                    <v-flex md4>
                      <enum-entity-field
                        namespace="pays"
                        v-model="currentAdresse.pays"
                        :additionalField="
                          Array.from(['unionEuropeenne', 'raccourci'])
                        "
                        i18n="adresse.pays"
                        sortBy="label"
                        :disabled="form.adresseFacturationIdentique"
                        :validation="$v.form.adresseFacturation.pays"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </crud-detail>
    </v-fade-transition>
  </div>
</template>

<script>
import DetailCrud from '@/plugins/DetailCrud'
import moment from 'moment'
import DateFormatter from '@/plugins/mixins/DateFormatter'
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import ValidationRules from '@/plugins/mixins/ValidationRules'
import { validationMixin } from 'vuelidate'
import { maxLength } from 'vuelidate/lib/validators'
import Api from '@/utils/api'

const NAMESPACE = 'correspondant/etablissement'

export default {
  props: {
    isCorrespondantEtablissement: {
      type: Boolean,
      default: false,
    },
    isCorrespondantEntreprise: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    DetailCrud,
    DateFormatter,
    ErrorServeur,
    ValidationRules,
    validationMixin,
  ],

  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    }
  },
  data() {
    return {
      namespace: NAMESPACE,
      validate: false,
      communesPossibles: [],
      communesPossiblesFacturation: [],
      localLocalite: '',
      localiteVisible: false,
      localLocaliteFacturation: '',
      localiteFacturationVisible: false,
      form: {
        adresse: {},
        adresseFacturation: {},
        adresseFacturationIdentique: false,
      },
      currentAdresse: {},
    }
  },
  created() {},
  beforeMount() {
    new Api('adresse').get().then((response) => {
      this.initForm(response.body)
      this.setInitialFormDigest()
    })
  },
  mounted() {},
  computed: {
    roleCorrespondant() {
      return this.$auth.hasRole('ROLE_CORRESPONDANT')
    },
  },
  watch: {
    'form.adresse'() {
      this.setInitialFormDigest()
    },
    'form.adresse.codePostal'(val) {
      this.searchCommunes(val).then((response) => {
        if (response) {
          this.localiteVisible = true
          this.form.adresse.pays = {
            id: 716,
            label: 'FRANCE',
            raccourci: '0033',
            unionEuropeenne: true,
          }
        }
      })
    },
    'form.adresseFacturation.codePostal'(val) {
      this.searchCommunesFacturation(val).then((response) => {
        if (response) {
          this.localiteFacturationVisible = true
          this.currentAdresse.pays = {
            id: 716,
            label: 'FRANCE',
            raccourci: '0033',
            unionEuropeenne: true,
          }
        }
      })
    },
    'form.adresseFacturationIdentique'(val) {
      if (val) {
        this.currentAdresse = this.form.adresse
      } else {
        this.currentAdresse = this.form.adresseFacturation
      }
    },
    localLocalite(val) {
      this.form.adresse.localite = val
    },
    localLocaliteFacturation(val) {
      this.currentAdresse.localite = val
    },
  },
  methods: {
    initForm(loaded) {
      if (loaded) {
        this.form = loaded
        this.id = loaded.id
        if (loaded.adresseFacturationIdentique) {
          this.currentAdresse = loaded.adresse
        } else if (this.isCorrespondantEtablissement) {
          this.currentAdresse = loaded.adresseFacturation
        }
      }
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
    customSave() {
      this.validate = true
      this.$v.$touch()

      this.save()
      if (!this.$v.form.$invalid) {
        this.validate = false
      }
      new Api('adresse').get().then((response) => {
        this.initForm(response.body)
        this.setInitialFormDigest()
      })
    },
    searchCommunes(val) {
      if (val && val.length >= 5 && !this.form.adresse.localite) {
        return this.$api('adresse/code-postal')
          .get({ params: { codePostal: val } })
          .then((response) => {
            this.communesPossibles = response.body
            if (this.communesPossibles.length === 1) {
              this.form.adresse.localite = this.communesPossibles[0]
            }
            return true
          })
          .catch(() => {})
      }
      return Promise.resolve(false)
    },
    searchCommunesFacturation(val) {
      if (val && val.length >= 5 && !this.currentAdresse.localite) {
        return this.$api('adresse/code-postal')
          .get({ params: { codePostal: val } })
          .then((response) => {
            this.communesPossiblesFacturation = response.body
            if (this.communesPossiblesFacturation.length === 1) {
              this.currentAdresse.localite =
                this.communesPossiblesFacturation[0]
            }
            return true
          })
          .catch(() => {})
      }
      return Promise.resolve(false)
    },
  },
  validations: {
    form: {
      contact: {},
      adresse: {
        codePostal: {
          maxLength: maxLength(10),
        },
      },
      adresseFacturation: {
        codePostal: {
          maxLength: maxLength(10),
        },
      },
    },
  },
}
</script>

<style scoped>
.custom-save {
  border-radius: 5px;
}

.custom-delete {
  border-radius: 5px;
}

.custom-message {
  background-color: var(--v-primary-base);
}

.v-subheader {
  background-color: var(--v-updatedGrey-base);
  color: white !important;
  border-radius: 5px;
  font-size: 13px;
}

.subheaderSpecificColor .v-subheader {
  background-color: var(--v-rose-base) !important;
}

.v-subheader .v-icon {
  color: white;
}

.custom-yellow-badge >>> .v-badge__badge {
  background-color: var(--v-yellow-base) !important;
}
</style>
<style>
.specific table.v-table tbody td {
  font-size: 11px;
}

.specific .material-icons {
  font-size: 18px;
}
.specificTableau .v-messages {
  display: none;
}

.specificTableau .v-input__slot {
  margin-bottom: 0px !important;
}

.specific .v-system-bar--window {
  height: 23px !important;
}

.specific .v-subheader {
  height: 23px !important;
}

.specificCloseBtn .v-btn--floating.v-btn--small {
  height: 33px !important;
  min-width: 0;
  padding: 0;
  width: 33px !important;
}
.specific .v-chip .v-chip__content {
  height: 26px;
}
.smallChip .v-chip {
  font-size: 10px !important;
  height: 20px;
}
.smallChip .v-chip .v-avatar {
  height: 20px !important;
  min-width: 20px;
  width: 20px !important;
}

.specific .v-avatar {
  height: 28px !important;
  width: 28px !important;
}

.reduceDialogClass {
  top: 4.10417px !important;
  position: fixed !important;
  margin: 0px !important;
  transition: none 0s ease 0s !important;
}
</style>
